export default __webpack_public_path__ + "static/media/SettingPage.f00bab16.svg";